import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CrmState } from './crm.reducer';

// Feature selector
export const selectCrmState = createFeatureSelector<CrmState>('crm');

// Contact Selectors
export const selectContacts = createSelector(
  selectCrmState,
  (state) => state?.contacts || []
);

export const selectContactsLoading = createSelector(
  selectCrmState,
  (state) => state?.contactsLoading || false
);

export const selectContactsError = createSelector(
  selectCrmState,
  (state) => state?.contactsError || null
);

export const selectContactsPagination = createSelector(
  selectCrmState,
  (state) => state?.contactsPagination || {
    total: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
    from: 0,
    to: 0
  }
);

export const selectContactDetail = createSelector(
  selectCrmState,
  (state) => state?.contactDetail || null
);

export const selectContactDetailLoading = createSelector(
  selectCrmState,
  (state) => state?.contactDetailLoading || false
);

export const selectContactDetailError = createSelector(
  selectCrmState,
  (state) => state?.contactDetailError || null
);

export const selectContactsLookup = createSelector(
  selectCrmState,
  (state) => state?.contactsLookup || []
);

export const selectContactsLookupLoading = createSelector(
  selectCrmState,
  (state) => state?.contactsLookupLoading || false
);

// Company Selectors
export const selectCompanies = createSelector(
  selectCrmState,
  (state) => state?.companies || []
);

export const selectCompaniesLoading = createSelector(
  selectCrmState,
  (state) => state?.companiesLoading || false
);

export const selectCompaniesError = createSelector(
  selectCrmState,
  (state) => state?.companiesError || null
);

export const selectCompaniesPagination = createSelector(
  selectCrmState,
  (state) => state?.companiesPagination || {
    total: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
    from: 0,
    to: 0
  }
);

export const selectCompanyDetail = createSelector(
  selectCrmState,
  (state) => state?.companyDetail || null
);

export const selectCompanyDetailLoading = createSelector(
  selectCrmState,
  (state) => state?.companyDetailLoading || false
);

export const selectCompanyDetailError = createSelector(
  selectCrmState,
  (state) => state?.companyDetailError || null
);

export const selectCompaniesLookup = createSelector(
  selectCrmState,
  (state) => state?.companiesLookup || []
);

export const selectCompaniesLookupLoading = createSelector(
  selectCrmState,
  (state) => state?.companiesLookupLoading || false
);

// Deal Selectors
export const selectDeals = createSelector(
  selectCrmState,
  (state) => state?.deals || []
);

export const selectDealsLoading = createSelector(
  selectCrmState,
  (state) => state.dealsLoading
);

export const selectDealsError = createSelector(
  selectCrmState,
  (state) => state.dealsError
);

export const selectDealsPagination = createSelector(
  selectCrmState,
  (state) => state.dealsPagination
);

export const selectDealDetail = createSelector(
  selectCrmState,
  (state) => state?.dealDetail || null
);

export const selectDealDetailLoading = createSelector(
  selectCrmState,
  (state) => state?.dealDetailLoading || false
);

export const selectDealDetailError = createSelector(
  selectCrmState,
  (state) => state?.dealDetailError || null
);

// Operation Selectors
export const selectOperationResult = createSelector(
  selectCrmState,
  (state) => state.operationResult
);

export const selectOperationLoading = createSelector(
  selectCrmState,
  (state) => state.operationLoading
);

export const selectOperationError = createSelector(
  selectCrmState,
  (state) => state.operationError
);

// Helper selectors
export const selectContactById = (id: number) => createSelector(
  selectContacts,
  (contacts) => contacts.find(contact => contact.id === id)
);

export const selectCompanyById = (id: number) => createSelector(
  selectCompanies,
  (companies) => companies.find(company => company.id === id)
);

export const selectDealById = (id: number) => createSelector(
  selectDeals,
  (deals) => deals.find(deal => deal.id === id)
);

// Save Report to CRM Selectors
export const selectSaveReportLoading = createSelector(
  selectCrmState,
  (state) => state?.saveReportLoading || false
);

export const selectSaveReportResult = createSelector(
  selectCrmState,
  (state) => state?.saveReportResult || null
);

export const selectSaveReportError = createSelector(
  selectCrmState,
  (state) => state?.saveReportError || null
);
